import { Profession } from "../../common/redux/professionAction";

export interface ProfessionnelMission {
    id: string;
    ref: string;
    name: string;
    job: Profession;
    startDate: string;
    endDate: string;
    dailyWorkingTime: number;
    hasPendingTimeSheets: boolean;
    startDayTime: string;
    endDayTime: string;
    dailyBilling: boolean;
    status: string;
    professional: {
        nom: string;
        prenom: string;
    };
    structure: {
        societe: string;
        ville: null;
    };
    timeSheets: [
        {
            id: string;
            startDate: string;
            endDate: string;
            status: string;
        }
    ];
}

export interface ProfessionnelMissionStats {
    id: string;
    name: string;
    dailyBilling: boolean;
    startDate: {
        date: string;
        timezone_type: number;
        timezone: string;
    };
    endDate: {
        date: string;
        timezone_type: number;
        timezone: string;
    };
    totals: {
        time: string;
        amount: number;
    };
}

export const initialProfessionnelMission: ProfessionnelMission = {
    id: "",
    ref: "",
    name: "",
    job: {
        id: 0,
        name: "",
        translations: {},
    },
    startDate: "",
    endDate: "",
    dailyWorkingTime: 0,
    hasPendingTimeSheets: false,
    startDayTime: "",
    endDayTime: "",
    dailyBilling: false,
    status: "",
    professional: {
        nom: "",
        prenom: "",
    },
    structure: {
        societe: "",
        ville: null,
    },
    timeSheets: [
        {
            id: "",
            startDate: "",
            endDate: "",
            status: "",
        },
    ],
};
